export default "__VITE_ASSET__qj4UMvqj__"